import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Durée quotidienne saisie au format « 7h45 » (ticket COMPETENCE, PRED-3286).
 * Conversions libellé ↔ heures décimales et validation (pas de 15 min, bornes).
 */
export const HOURS_LABEL_PATTERN = /^(\d{1,2})h([0-5]\d)$/;

/** Nombre d'heures d'une journée de travail par défaut (repli des tickets antérieurs). */
export const DEFAULT_DAILY_HOURS = 7;

/** Pas de quantité des tickets COMPETENCE : un quart d'heure. */
export const HOURS_STEP = 0.25;

/** « 7h45 » → 7.75 ; null si le format est invalide. */
export const parseHoursLabel = (label: string | null | undefined): number | null => {
  const match = HOURS_LABEL_PATTERN.exec((label ?? '').trim());
  if (!match) {
    return null;
  }
  return Number(match[1]) + Number(match[2]) / 60;
};

/** 7.75 → « 7h45 ». */
export const formatHoursLabel = (hours: number | null | undefined): string => {
  const value = hours ?? DEFAULT_DAILY_HOURS;
  const wholeHours = Math.floor(value);
  const minutes = Math.round((value - wholeHours) * 60);
  return `${wholeHours}h${String(minutes).padStart(2, '0')}`;
};

/**
 * Valide un libellé « 7h45 » : `pattern` si le format est mauvais, `customError` si la
 * valeur est hors bornes ou n'est pas un multiple du pas (messages portés par base-form-input).
 */
export const hoursLabelValidator =
  (min = HOURS_STEP, max = 24, step = HOURS_STEP): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }
    const hours = parseHoursLabel(control.value);
    if (hours === null) {
      return { pattern: true };
    }
    const ratio = hours / step;
    const isMultipleOfStep = Math.abs(ratio - Math.round(ratio)) < 1e-9;
    if (hours < min || hours > max || !isMultipleOfStep) {
      return { customError: true };
    }
    return null;
  };
